/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Optional description" |
*
* @param {Tfield_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_description_placeholder = /** @type {((inputs?: Tfield_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Description_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description optionnelle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción opcional")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Descrição opcional")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione facoltativa")
	return /** @type {LocalizedString} */ ("Optional description")
});